import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const AdminPage = lazy(() => import("./web/AdminPage.js").then((m) => ({ default: m.AdminPage })));
const MinePage = lazy(() => import("./web/MinePage.js").then((m) => ({ default: m.MinePage })));

export default defineWebModule({ manifest, pages: { "": AdminPage, "/mine": MinePage } });
